module.exports = __webpack_public_path__ + "img/TE.fe346759.png";